class uspPopup {
  constructor() {
    this.target = 'trial' //default

    this.template = document.querySelector('.jsUspTemplate').content

    this.content = JSON.parse(
      this.template.querySelector('.jsUspContent').innerHTML
    )

    this.icon = this.template.querySelector('img')
    this.icon_wrapper = this.template.querySelector('.usp-popup__icon')
    this.title = this.template.querySelector('.usp-popup__title')
    this.body = this.template.querySelector('.usp-popup__body')

    this.openers = document.querySelectorAll('.jsUspPopup')

    if (this.openers.length > 0) {
      this.init()
    }
  }

  init() {
    this.openers.forEach((opener) => {
      opener.style.cursor = 'pointer'
      opener.addEventListener('click', (e) => {
        e.preventDefault()
        this.updateContent(opener)
      })
    })
  }

  updateContent(e) {
    console.log(e.dataset.target)
    let icon = e.querySelector('img').src
    this.target = e.dataset.target
    this.icon.src = icon

    if (e.dataset.target == 'trial') {
      this.icon_wrapper.style = 'max-width: 70px;'
    } else if (e.dataset.target == 'usa') {
      this.icon_wrapper.style = 'max-width: 50px;'
    } else if (e.dataset.target == 'shipping') {
      this.icon_wrapper.style = 'max-width: 50px;'
    } else if (e.dataset.target == 'delivery') {
      this.icon_wrapper.style = 'max-width: 50px;'
    } else {
      this.icon_wrapper.style = ''
    }

    this.title.innerHTML = this.content[this.target].title

    if (e.dataset.target == 'shipping' && puffy.product.type == 'mattress') {
      this.title.classList.add('remove-break')
    } else {
      this.title.classList.remove('remove-break')
    }

    this.body.innerHTML = this.content[this.target].content
    this.appendPopup()
    this.closeButtonsEvents()
  }

  appendPopup() {
    document.body.appendChild(this.template.cloneNode(true))
  }

  closePopup() {
    let closeWrapper = document.querySelector('.jsUspWrapper')
    if (closeWrapper) {
      closeWrapper.remove()
    }
  }

  closeButtonsEvents() {
    let closers = document.querySelectorAll('.jsUspClose')
    let wrapper = document.querySelector('.jsUspWrapper')

    document.addEventListener('keyup', (e) => {
      if (e.keyCode === 27) {
        this.closePopup()
      }
    })

    wrapper.addEventListener('click', (e) => {
      if (e.target === e.currentTarget) {
        this.closePopup()
      }
    })

    closers.forEach((closer) => {
      closer.addEventListener('click', (e) => {
        e.preventDefault()
        this.closePopup()
      })
    })
  }
}

const uspPop = new uspPopup()
